import axios from "../../config/axiosConfig";
import {
  ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_REQUEST,
  ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_SUCCESS,
  ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE,
  ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_REQUEST,
  ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_SUCCESS,
  ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_FAILURE,
  ORDER_DELIVERY_SCHEDULE_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS,
  SET_OUTSTANDING_BY_ACCOUNTS_DELI_SCHEDULE
} from "../types/order-delivery-schedule-balance-stock-report-types";


export const getOrderDeliveryScheduleBalanceBillBaseReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getOrderDeliveryScheduleBalanceDetailReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('>>>API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order delivery schedule  balance(bill base) Report:", error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order delivery schedule  balance(bill base) Report:", error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getOrderDeliveryScheduleBalanceStockFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/stock-report/getOrderDeliveryScheduleBalanceDetailsOptions?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching order delivery schedule  balance(bill base) Report:", error);
                dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching order delivery schedule  balance(bill base) Report:", error);
            dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearOrderDeliveryScheduleBalanceStockReport = () => {
  return async (dispatch) => {
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_SUCCESS, payload: {} });
  }
}

// export const closeOrderWithTransaction = (orderId, transactionId) => {
//   return async (dispatch, getState) => {
//     try {
//       const queryString = new URLSearchParams({ orderId, transactionId }).toString();
//       const fullUrl = `/sales-order/closeOrder?${queryString}`;
//       // Make API call
//       return axios.put(fullUrl).then((response) => {
//         console.log('API Response Data: ', response);
//         if (response.data) {
//           return response;
//         }
//       }).catch((error) => {
//         console.error("Error closing order:", error);
//         throw error;
//       });
//     } catch (error) {
//       console.error("Error closing order:", error);
//       throw error;
//     }
//   };
// };

// export const getOutstandingByAccountsInDeliSchedule = (accountIds) => {
//   return async (dispatch, getState) => {
//     try {
//       const params = { accountIds };

//       const queryString = new URLSearchParams(params).toString();
//       const fullUrl = `/dashboard/getReceivableOutstandingByAccounts?${queryString}`;

//       console.log('Complete API Request URL: ', fullUrl);

//       // Make API call
//       return axios.get(fullUrl).then((response) => {
//         console.log('API Response Data: ', response);
//         // Dispatch success action with data
//         if (response.data) {
//           dispatch({ type: SET_OUTSTANDING_BY_ACCOUNTS_DELI_SCHEDULE, payload: response.data });
//         }
//       }).catch((error) => {
//         console.error("Error fetching order delivery schedule  balance(bill base) Report:", error);
//         dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
//       });
//     } catch (error) {
//       console.error("Error fetching order delivery schedule balance(bill base) Report:", error);
//       dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
//     }
//   };
// };

export const getReceivableOutstandingByAccountsInDeliSchedule = (accountIds) => {
  return async (dispatch, getState) => {
    try {
      // const { auth } = getState();
      // const params = { companyId: auth.company?.id };
      // const data = { ...params };
      // Make API call
      return axios.post('/outstanding-report/sales-outstanding-by-account-ids', { accountIds }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SET_OUTSTANDING_BY_ACCOUNTS_DELI_SCHEDULE, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order delivery schedule  balance(bill base) Report:", error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order delivery schedule balance(bill base) Report:", error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getOrderDeliveryScheduleBalanceChallanBaseReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };
      console.log('Request Param Datas >>', requestParams);

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getOrderDeliveryScheduleBalanceDetailReport?${queryString}`;

      console.log('>Complete API Request URL: ', fullUrl);

      return axios.get(fullUrl).then((response) => {
        console.log('>>>API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order delivery schedule balance(challan base) Report:", error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order delivery schedule balance(challan base) Report:", error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};
export const clearOrderDeliveryScheduleBalanceChallanBaseStockReportReport = () => {
  return async (dispatch) => {
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS, payload: {} });
  }
}


export const updateSaleSecondStatusInOrderDeliveryScheduleTransaction = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/order-delivery-schedule/update-show-sale-second", { id, data },
        { params: { userId: auth.user?.id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const updateSaleStatusInOrderDeliveryScheduleTransaction = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/order-delivery-schedule/update-show-sale", { id, data },
        { params: { userId: auth.user?.id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};